import React from 'react';

import './MainAdminHeader.scss';

const MainAdminHeader = (props) => {
  return <header className={props.className}>{props.children}</header>;
};

export default MainAdminHeader;
